import { render, staticRenderFns } from "./luckyDetails.vue?vue&type=template&id=2430850a&scoped=true&"
import script from "./luckyDetails.vue?vue&type=script&lang=js&"
export * from "./luckyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2430850a",
  null
  
)

export default component.exports